const SCROLL_LOAD_THRESHOLD = 100

const InfiniteScrollMixin = {

  handleInfiniteScroll (fn, e) {
    const wrapper = e.target
    const child = e.target.children[0]
    const scrollLength = wrapper.scrollTop
    const wrapperHeight = wrapper.offsetHeight
    const childHeight = child.offsetHeight

    if (childHeight - (wrapperHeight + scrollLength) < SCROLL_LOAD_THRESHOLD) {
      fn()
    }
  },

}

module.exports = InfiniteScrollMixin
